// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    iFrameRatio?: string;
    src: string;
}

export interface EmbededIFrameStyles {
    iFrameWrapper?: InjectableCss;
}

export const embededIFrameStyles: EmbededIFrameStyles = {
    iFrameWrapper: {
        css: css`
            position: relative;
            width: 100%;
            overflow: hidden;
            iframe {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border: none;
            }
        `,
    },
};

type Props = OwnProps;
const styles = embededIFrameStyles;

const IFrame: FC<Props> = ({ src, iFrameRatio = "56.25%" }) => {
    const iFrameWrapperStyles: InjectableCss = {
        ...styles.iFrameWrapper,
        css: css`
            ${styles.iFrameWrapper?.css}
            padding-top: ${iFrameRatio};
        `,
    };

    return (
        <StyledWrapper {...iFrameWrapperStyles}>
            <iframe src={src} allowFullScreen></iframe>
        </StyledWrapper>
    );
};

export default IFrame;
